import { render, staticRenderFns } from "./BrokerPickerPopUp.vue?vue&type=template&id=23d6fb9c&scoped=true&"
import script from "./BrokerPickerPopUp.vue?vue&type=script&lang=js&"
export * from "./BrokerPickerPopUp.vue?vue&type=script&lang=js&"
import style0 from "./BrokerPickerPopUp.vue?vue&type=style&index=0&id=23d6fb9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d6fb9c",
  null
  
)

export default component.exports